/**
 * Yellow banner shown whenever an admin is impersonating a student account.
 * One click restores the admin session. Driven by sessionStorage so it
 * vanishes when the tab is closed.
 */
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, LogOut } from "lucide-react";

const KEY = "hccbc_admin_resume";

export default function ImpersonationBanner() {
    const [stash, setStash] = useState(null);

    useEffect(() => {
        try {
            const raw = sessionStorage.getItem(KEY);
            if (raw) setStash(JSON.parse(raw));
        } catch (_e) { /* ignore */ }
    }, []);

    if (!stash) return null;

    const returnToAdmin = () => {
        try {
            if (stash.admin_token) localStorage.setItem("token", stash.admin_token);
            sessionStorage.removeItem(KEY);
            toast.success("Returned to admin session");
            window.location.href = "/dashboard/admin";
        } catch (_e) {
            toast.error("Could not restore admin session — please log in again");
        }
    };

    return (
        <div
            className="fixed top-0 left-0 right-0 z-[100] bg-amber-400 text-amber-950 border-b-2 border-amber-600 px-4 py-2 flex items-center justify-center gap-3 text-sm shadow-md"
            data-testid="impersonation-banner"
        >
            <ShieldCheck className="h-4 w-4" />
            <span>
                You&apos;re logged in as <strong>{stash.target_email}</strong>.
            </span>
            <button
                type="button"
                onClick={returnToAdmin}
                className="inline-flex items-center gap-1 px-3 py-1 rounded bg-amber-950 text-amber-100 hover:bg-amber-900 transition text-xs font-semibold"
                data-testid="return-to-admin-btn"
            >
                <LogOut className="h-3 w-3" />
                Return to admin
            </button>
        </div>
    );
}
